export default "__VITE_ASSET__T7DAA_TW__"